import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { LayoutContext } from "App/Layout/store";
import {CircularProgress} from '@material-ui/core';
import Backdrop from './Backdrop'

const AxiosErrorHandler = ({ children }) => {
    const layoutContext = useContext(LayoutContext);
    const [cargando, setCargando] = useState(0)
    useEffect(() => {
        const requestInterceptor = axios.interceptors.request.use(config=>{
            if(!config.noBloquea) setCargando(true)
            return config
        })
        const responseInterceptor = axios.interceptors.response.use(response => {
            setCargando(false)
            return response.data
        }, async (error) => {
                //EN EL FUTURO HACER ALGO CON EL ERROR
                setCargando(false)
                var e = error;
                try{
                  e = error.response.data.Mensaje||e
                }catch{}
                if(!error.response?.config?.skipError) Swal.fire(
                  {
                    icon: 'error',
                    text: e||'Ocurrió un error al rescatar los datos'
                  }
                )
                return Promise.reject(error);
        })

        return () => {
            axios.interceptors.response.eject(responseInterceptor);
            axios.interceptors.request.eject(requestInterceptor);
        }
    }, [])

    return <>
    {cargando?<Backdrop
        style={{zIndex: 999}}
        open={cargando}
      >
        <CircularProgress style={{zIndex:999}} color="inherit" />
      </Backdrop>:null}
    {children}
    </>
}

export default AxiosErrorHandler